import React from "react";
import LinkedinIcon from "../images/Linkedin.svg";
import UserIcon from "../images/userPlaceholder.jpg";
import { useTranslation } from "react-i18next";

const CounterPart = ({ data, title, subtitle }) => {
  const { t } = useTranslation();

  const bugBountry = ({ image, num, name, profileUrl, roleDescription }, i, title) => {
    return (
      <div key={i} className={`items-center flex flex-col justify-between leading-7 ${title === t("team") ? `` : " gap-4"}`}>
        <div className="flex flex-col items-center">
          <div className="rounded-[10px] inline-block">
            <img draggable="false" src={image ? image : UserIcon} className={`${title === t("domain_experts") ? "h-[35px] sm:h-[55px]" : "h-[85px] w-[85px] sm:h-[110px] sm:w-[110px] object-cover border"}  rounded-full`} alt="name" />
            {/* <img draggable="false" src={image} className={`h-[85px] w-[85px] sm:h-[110px] sm:w-[110px] object-cover border rounded-full`} alt="name" /> */}
          </div>
          <div className="text-center">
            <div className="sora text-[#141619] text-[16px] sm:text-[14px] md:text-[20px] 3xl:text-[24px] font-[700] pt-1 px-0">
              {num}
            </div>
            <span className={`sora text-[#676767] text-[12px] sm:text-[14px] ${title === t("domain_experts") ? "" : "md:text-[16px]"}  3xl:text-[18px] px-0 text-center`}>
              {name}
            </span>
          </div>

          {title === t("team") ? (
            <p className="sora text-[10px] text-center mb-3 w-[214px] leading-5">{roleDescription}</p>
          ) : null}
        </div>


        {title === t("team") ? (
          <div className="inline-block">
            {profileUrl ? (
              <a href={profileUrl} target="_blank" rel="noreferrer">
                <img draggable="false" src={LinkedinIcon} className="h-[35px] sm:h-[38px]" alt="name" />
              </a>
            ) : (
              <img draggable="false" src={LinkedinIcon} className="h-[35px] sm:h-[38px]" alt="name" />
            )}

          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div
      // className={`border border-[#C0CDF8] rounded-[30px] py-[22px] md:py-[33px]  3xl:py-[30px] px-[10px] sm:px-[27px] md:px-[47px] 3xl:px-[42px] bg-gradient-to-br from-purple-200 via-transparent to-purple-200 h-full ${title === "Team" ? `w-full sm:w-fit lg:w-[50%] mx-auto` : ``}`}
      className={`rounded-[30px] py-[22px] md:py-[33px]  3xl:py-[30px] px-[10px] sm:px-[27px] md:px-[47px] 3xl:px-[42px] h-full ${title === t("team") ? `w-full sm:w-fit lg:w-[65%] mx-auto` : ``}`}
    // style={{ background: "linear-gradient(142deg, #3359D3 -32.12%, rgba(255, 255, 255, 0) 10.66%, rgba(255, 255, 255, 0) 94.58%, #3359D3 126.44%)", }}
    >
      <div className="mb-6">
        {title ? (
          <p className="sora sm:leading-[42px] text-[20px] sm:text-[28px] 3xl:text-[34px] font-[700]  text-[#000] text-center mb-2">{title}</p>
        ) : null}
        {subtitle ? (
          <p className={`sora font-medium text-center text-[10px] max-w-[400px] mx-auto`}>{subtitle}</p>
        ) : null}
      </div>
      <div
        // className={`grid ${title === "Team" ? `sm:grid-cols-${data.length} md:grid-cols-2 lg:grid-cols-${data.length}` : `grid-cols-1`}  gap-3 sm:gap-6 `}
        className={`grid ${title === t("team") ? `sm:grid-cols-${data.length} md:grid-cols-2 lg:grid-cols-${data.length}` : `sm:grid-cols-1 ${title === t("domain_experts") ? `md:grid-cols-4` : `md:grid-cols-3 `}`}  gap-8 sm:gap-6 `}
      >
        {data.map((item, i) => bugBountry(item, i, title))}
      </div>

    </div>
  );
};

export default CounterPart;
